export default __webpack_public_path__ + "static/media/home_icon.2c42a871.svg";